import React, { useState } from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    TextField,
    Alert
} from '@mui/material';

const AddTimeoffModal = ({ open, onClose, onTimeoffAdded, backendUrl, authTokens, currentRelationship }) => {
    const [timeoffName, setTimeoffName] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async () => {
        if (!timeoffName.trim()) {
            setError('Timeoff name is required');
            return;
        }

        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${backendUrl}api/timeoffs/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authTokens.access}`,
                },
                body: JSON.stringify({
                    name: timeoffName.trim(),
                    relationship_id: currentRelationship?.relationship_id
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Failed to create timeoff');
            }

            const newTimeoff = await response.json();

            // Call the callback to update the timeoffs list
            onTimeoffAdded(newTimeoff);

            // Reset form and close modal
            handleClose();
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setTimeoffName('');
        setError('');
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Add New Time Off</DialogTitle>
            <DialogContent>
                {error && (
                    <Alert severity="error" sx={{ marginBottom: 2 }}>
                        {error}
                    </Alert>
                )}

                <TextField
                    label="Time Off Name"
                    value={timeoffName}
                    onChange={(e) => setTimeoffName(e.target.value)}
                    fullWidth
                    margin="normal"
                    required
                    placeholder="e.g., Vacation, Sick Leave, Personal Day"
                    inputProps={{ maxLength: 100 }}
                    helperText={`${timeoffName.length}/100`}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={loading || !timeoffName.trim()}
                >
                    {loading ? 'Adding...' : 'Add Time Off'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddTimeoffModal;